import { Component } from '@angular/core';

import { Platform, IonTabs } from '@ionic/angular';
import { SplashScreen, } from '@capacitor/splash-screen';
import { StatusBar,Style } from '@capacitor/status-bar';
import { Router, ActivatedRoute,RouterModule } from '@angular/router';
import { AuthenticationService } from './services/authentication.service';
//import { AdalService } from 'adal-angular4';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { AppSettings } from './app.settings';
import { SwUpdate } from '@angular/service-worker';
import { EventService } from './services/event.service';
import { TranslateService } from '@ngx-translate/core';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from '../../src/environments/environment';
import { RestService } from './services/rest.service';

import { StorageService } from './services/storage.service';


const TOKEN_KEY = 'auth-token';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  [x: string]: any;
  navigate: any;
  isIframe: boolean = false;

  isAppUpdate: boolean = false;
  calledFromIndent = false;
  userDetails: any = {};
  salecallReportLabel: string = '';
  configrations: any;

  private readonly _destroying$ = new Subject<void>();




  constructor(
    private platform: Platform,
    private router: Router,
    private route:ActivatedRoute,
    private authenticationService: AuthenticationService,
    // private adal: AdalService,
    private msalBroadcastService: MsalBroadcastService,
    private msalService: MsalService,
    private event: EventService,
    private swUpdates: SwUpdate,
    private translate: TranslateService,
    private restService: RestService,
    private storageService: StorageService
  ) {
    // this.sideMenu();
    this.initStorage();
    
    



    // this.storage.get(AppSettings.CALLED_FROM_INDENT).then((res: boolean)=>{
    //   debugger
    //   this.calledFromIndent = res;        
    // });   


    
    

  }

  async initStorage() { 
    await this.storageService.init();
    this.calledFromIndent = false;
    AppSettings.USER_LANG = "kr";
    this.translate.setDefaultLang(AppSettings.USER_LANG);
    this.translate.use(AppSettings.USER_LANG);
    this.swUpdates.available.subscribe(event => {
      this.isAppUpdate = true;
    })
    await this.initializeApp();
  }

  async indentLogin() { 
    this.isIframe = window !== window.parent && !window.opener;
    
    try {
      // Initialize MSAL first
      console.log('Initializing MSAL...');
      await this.msalService.instance.initialize();
      
      console.log('MSAL initialized, accounts:', this.msalService.instance.getAllAccounts());
      
      // Handle redirect promise after initialization
      const res = await this.msalService.instance.handleRedirectPromise();
      if (res != null && res.account != null) {
        this.msalService.instance.setActiveAccount(res.account);
      }
      
      // Subscribe to authentication state changes
      this.authenticationService.authenticationState.subscribe(state => {
        if (state) {
          //this.router.navigate(['dashboard'], { replaceUrl: true });
          // this.router.navigate(['landing'], { replaceUrl: true });
        } else {
          console.log('==  REDIRECT TO LOGIN ==')
          // Use setTimeout to avoid routing conflicts during initialization
         
            this.router.navigate(['login']);
   
        }
      });
      
    } catch (error) {
      console.error('Error initializing MSAL:', error);
      // Fallback navigation
     
        this.router.navigate(['login']);

    }
  }


  async ngOnInit() {
    let url = document.URL;
    await this.indentLogin();
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.msalService.instance.getActiveAccount();
    console.log('ACCOUNTS', activeAccount)
    if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
      let accounts = this.msalService.instance.getAllAccounts();
      console.log('ACCOUNTS', accounts)
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
  }



  ionViewDidEnter() {
  }

async initializeApp() {
    try {
      await this.platform.ready();
      
      // Only call StatusBar and SplashScreen on mobile platforms
      if (this.platform.is('capacitor')) {
        try {
          await StatusBar.setStyle({ style: Style.Default });
          await SplashScreen.hide();
        } catch (error) {
          console.warn('Error setting status bar or hiding splash screen:', error);
        }
      }
      
      const calledFromIndentStr = localStorage.getItem(AppSettings.CALLED_FROM_INDENT);
      this.calledFromIndent = calledFromIndentStr ? JSON.parse(calledFromIndentStr) : false;
      
      this.event.subscribe('user-details', userdetails => {
        console.log("User App Compoent:" + userdetails);
        this.userDetails = userdetails.UserProfileData;
        this.configrations = userdetails.Configurations;
        this.userName = userdetails.UserProfileData.FullName;
        this.roleName = userdetails.UserProfileData.RoleDesc;

        if (this.userDetails.BusinessUnit_Name === 'SPS') {
          this.salecallReportLabel = 'Landscape Report'
        } else {
          this.salecallReportLabel = 'Sales Call Report'
        }
        if (AppSettings.USER_LANG === "en") {
          this.Profile = "Profile";
          this.MasterData = "Master Data";
          this.InventoryData = "Inventory Data";
          this.CreditData = "Credit Data";
          this.CSPExcelAllocation = "CSP Allocation";
          this.TargetData = "Targets";
          this.indentReport = 'Indent Reports'
          this.Logout = "Logout";
          this.realtimeDashboard = 'Sales Dashbord',
          this.materialLiveStock = 'CSP Transaction Report',
          this.touch500SalesReport = 'Touch 500 Report',
          this.touch500Mater = 'Touch 500 Master',
          this.landscapeReport = 'Landscape Remarks'
        } else {
          this.Profile = "프로파일";
          this.MasterData = "마스터 데이터";
          this.InventoryData = "목록 데이터"
          this.CreditData = "신용 데이터";
          this.CSPExcelAllocation = "CSP 할당";
          this.TargetData = "가이드 데이터";
          this.Logout = "로그아웃";
          this.indentReport = 'Indent Reports',
          this.realtimeDashboard = '판매 대시보드',
          this.materialLiveStock = 'CSP Transaction Report',
          this.touch500SalesReport = 'Touch 500 Report',
          this.touch500Mater = 'Touch 500 Master',
          this.landscapeReport = 'Landscape Remarks'
        }
        this.event.isMenuClicked().subscribe(data => {
          this.sideMenu(userdetails.UserProfileData.RoleID);
        })

      });
    } catch (err) {
      console.error('Error initializing app', err);
    }
  }


  //Menu for DG App
  sideMenu(RoleID) {
    console.log(AppSettings.AppMenu);
    if (RoleID == 1) {
      this.navigate =
        [
          {
            title: this.Profile,
            url: './pages/profile/profile.module#ProfilePageModule',
            icon: "person",
            show: true
          },
          {
            title: this.Logout,
            url: "./public/login/login.module#LoginPageModule",
            icon: "power",
            show: true
          }
        ]
    }
    else if (RoleID == 2) {
      this.navigate =
        [
          {
            title: this.Profile,
            url: './pages/profile/profile.module#ProfilePageModule',
            icon: "person",
            show: true
          },
          {
            title: this.Logout,
            url: "./public/login/login.module#LoginPageModule",
            icon: "power",
            show: true
          },
        ]
    } else if (RoleID == 3) {
      console.log('AppSettings.AppMenu', AppSettings.AppMenu)
      if (AppSettings.AppMenu === "DG") {
        console.log('sales call dashboard trigger')
        this.navigate =
          [
            {
              title: this.Profile,
              url: './pages/profile/profile.module#ProfilePageModule',
              icon: "person",
              show: true
            },
            {
              title: this.MasterData,
              url: ".pages/master-data/master-data.module#MasterdataPageModule",
              icon: "logo-dropbox",
              show: true
            },
            {
              title: this.TargetData,
              url: "./pages/target-data/target-data.module#TargetDataPageModule",
              icon: "locate",
              show: true
            },
            {
              title: this.Logout,
              url: "./public/login/login.module#LoginPageModule",
              icon: "power",
              show: true
            }]

      } else if (AppSettings.AppMenu === "Indent") {
        this.navigate =
          [
            {
              title: this.Profile,
              url: './pages/profile/profile.module#ProfilePageModule',
              icon: "person",
              show: true
            },
            {
              title: this.realtimeDashboard,
              url: './pages/profile/profile.module#ProfilePageModule',
              icon: "logo-dropbox",
              show: true
            },
            {
              title: this.materialLiveStock,
              url: './pages/material-live-stock/material-live-stock.module#MaterialLiveStockPageModule',
              icon: "logo-dropbox",
              show: true
            },
            {
              title: this.MasterData,
              url: "./pages/master-data/master-data.module#MasterdataPageModule",
              icon: "logo-dropbox",
              show: true
            },
            {
              title: this.InventoryData,
              url: "./pages/inventory-data/inventory-data.module#InventoryDataPageModule",
              icon: "logo-dropbox",
              show: true
            },
            {
              title: this.CreditData,
              url: "./pages/credit-data/credit-data.module#CreditDataPageModule",
              icon: "logo-dropbox",
              show: true
            },
            {
              title: this.CSPExcelAllocation,
              url: "./pages/csp-data-allocation/csp-data-allocation.module#CspDataAllocationPageModule",
              icon: "logo-dropbox",
              show: true
            },
            {
              title: this.Logout,
              url: "./public/login/login.module#LoginPageModule",
              icon: "power",
              show: true
            }
          ]

      } else if (AppSettings.AppMenu === "SPS") {
        this.navigate = [
          {
            title: this.Profile,
            url: './pages/profile/profile.module#ProfilePageModule',
            icon: "person",
            show: true
          },
          {
            title: this.Logout,
            url: "./public/login/login.module#LoginPageModule",
            icon: "power",
            show: true
          }
        ]
      }
    } else if (RoleID === 4) {
      if (AppSettings.AppMenu === "Indent") {
        this.navigate = [
          {
            title: this.Profile,
            url: './pages/profile/profile.module#ProfilePageModule',
            icon: "person",
            show: true
          },
          {
            title: this.realtimeDashboard,
            url: './pages/profile/profile.module#ProfilePageModule',
            icon: "logo-dropbox",
            show: true
          }, {
            title: this.Logout,
            url: "./public/login/login.module#LoginPageModule",
            icon: "power",
            show: true
          }
        ]
      }
    } else if (RoleID === 5) {
      if (AppSettings.AppMenu === "Indent") {
        this.navigate = [
          {
            title: this.Profile,
            url: './pages/profile/profile.module#ProfilePageModule',
            icon: "person",
            show: true
          },
          {
            title: this.realtimeDashboard,
            url: './pages/profile/profile.module#ProfilePageModule',
            icon: "logo-dropbox",
            show: true
          },
          {
            title: this.Logout,
            url: "./public/login/login.module#LoginPageModule",
            icon: "power",
            show: true
          }
        ]
      }
    }

    if ((this.userDetails.IsCSEnabled && AppSettings.AppMenu === "Indent") || (RoleID === 1 && AppSettings.AppMenu === "Indent")) {
      this.navigate.splice(1, 0, {
        title: this.realtimeDashboard,
        url: './pages/profile/profile.module#ProfilePageModule',
        icon: "logo-dropbox",
        show: true
      })
    }
    if (this.userDetails.BussinessUnitId === 4 && RoleID === 3 && AppSettings.AppMenu === "DG") {
      this.navigate.splice(1, 0, {
        title: this.landscapeReport,
        url: "./pages/landscape-remarks-upload/landscape-remarks-upload.module#LandscapeRemarksUploadPageModulee",
        icon: "logo-dropbox",
        show: true
      })
      
    }
  

    if (this.configrations[0].EnableDGSaleDashBoard && AppSettings.AppMenu === "DG") {
      this.navigate.splice(1, 0, {
        title: this.salecallReportLabel,
        url: "./pages/sales-call-dashboard/sales-call-dashboard.module#SalesCallDashboardPageModule",
        icon: "locate",
        show: true
      })
    }






    if (AppSettings.AppMenu === "SPS") {
      this.navigate.splice(1, 0, {
        title: this.touch500SalesReport,
        url: './pages/touch500-sales-report/touch500-sales-report.module#Touch500SalesReportPageModule',
        icon: "logo-dropbox",
        show: true
      })
    }

    if (AppSettings.AppMenu === "SPS" && RoleID === 3) {
      this.navigate.splice(1, 0, {
        title: this.touch500Mater,
        url: './pages/touch500-master/touch500-master.module#Touch500MasterPageModule',
        icon: "logo-dropbox",
        show: true
      })
    }

  }

  //Indent side menu
  sideMenuIndent(RoleID) {
    if (RoleID == 1) {
      this.navigate =
        [
          {
            title: this.Profile,
            url: './pages/profile/profile.module#ProfilePageModule',
            icon: "person",
            show: true
          },

          {
            title: this.Logout,
            url: "./public/login/login.module#LoginPageModule",
            icon: "power",
            show: true
          },
        ]
    }
    else if (RoleID == 2) {
      this.navigate =
        [
          {
            title: this.Profile,
            url: './pages/profile/profile.module#ProfilePageModule',
            icon: "person",
            show: true
          },
          {
            title: this.Logout,
            url: "./public/login/login.module#LoginPageModule",
            icon: "power",
            show: true
          },
        ]
    } else if (RoleID == 3) {
      debugger

      this.navigate =
        [
          {
            title: this.Profile,
            url: './pages/profile/profile.module#ProfilePageModule',
            icon: "person",
            show: true
          },
          {
            title: this.MasterData,
            url: ".pages/master-data/master-data.module#MasterdataPageModule",
            icon: "logo-dropbox",
            show: true
          },
          {
            title: this.Logout,
            url: "./public/login/login.module#LoginPageModule",
            icon: "power",
            show: true
          },
        ]


    }
  }

  OpenPage(pages) {
    debugger
    if (AppSettings.USER_LANG === "en") {
      switch (pages.title) {
        case this.Profile:
          this.router.navigate(['profile', { calledFromIndent: false, appName: AppSettings.AppMenu }]);
          break;
        case this.MasterData:
          this.router.navigate(['master-data']);
          break;
        case this.InventoryData:
          this.router.navigate(['inventory-data']);
          break;
        case this.CreditData:
          this.router.navigate(['credit-data']);
          break;
        case this.CSPExcelAllocation:
          this.router.navigate(['csp-data-allocation']);
          break;
        case this.TargetData:
          this.router.navigate(['target-data']);
          break;
        case this.indentReport:
          this.router.navigate(['indent-reports']);
          break;
        case this.realtimeDashboard:
          this.router.navigate(['realtime-dashboard']);
          break;
        case this.materialLiveStock:
          this.router.navigate(['material-live-stock']);
          break;
        case this.touch500SalesReport:
          this.router.navigate(['touch500-sales-report']);
          break;
        case this.salecallReportLabel:
          this.router.navigate(['sales-call-dashboard']);
          break;

        case this.landscapeReport:
          this.router.navigate(['landscape-remarks-upload']);
          break;

        case this.Logout:
          this.logout();
          break;
      }
    } else {
      switch (pages.title) {
        case this.Profile:
          this.router.navigate(['profile', { calledFromIndent: false, appName: AppSettings.AppMenu }]);
          break;
        case this.MasterData:
          this.router.navigate(['master-data']);
          break;
        case this.InventoryData:
          this.router.navigate(['inventory-data']);
          break;
        case this.CreditData:
          this.router.navigate(['credit-data']);
          break;
        case this.CSPExcelAllocation:
          this.router.navigate(['csp-data-allocation']);
          break;
        case this.TargetData:
          this.router.navigate(['target-data']);
          break;
        case this.realtimeDashboard:
          this.router.navigate(['realtime-dashboard']);
          break;
        case this.materialLiveStock:
          this.router.navigate(['material-live-stock']);
          break;
        case this.touch500SalesReport:
          this.router.navigate(['touch500-sales-report']);
          break;
        case this.salecallReportLabel:
          this.router.navigate(['sales-call-dashboard']);
          break;

        case this.landscapeReport:
          this.router.navigate(['landscape-remarks-upload']);
          break;

        case this.Logout:
          this.logout();
          break;
      }

    }
  }

  logout() {
    this.authenticationService.logout();
  }
}
